<template>
    <div class="container">
        <!-- <div class="row profile">
            <div class="col col-12">
                <p>Strona w budowie</p>
            </div>
        </div> -->
        <div class="row">
            <div class="col col-4">
                <h2 class="h h--2 h--dark">{{ quiz.name }}</h2>
                <p class="paragraph">{{ quiz.description }}</p>
            </div>
            <div class="col col-8">
                <div v-for="(question, qindex) in quiz.questions">
                    <p class="paragraph"><b>{{ qindex + 1 }}. {{ question.description }}</b></p>
                    <img v-auth-image="'/photos/' + question.photo_id" alt="" class="quiz__question-img" v-if="question.photo_id">
                    <div v-if="!question.draggable">
                        <div class="form__input-container" v-for="(answer, aindex) in question.answers">
                            <input type="checkbox" name="showPrizes[]" :id="'showPrizes-' + answer.id" class="form__checkbox" v-model="answer.checked">
                            <label :for="'showPrizes-' + answer.id">
                                <span>{{ answer.content }}</span>
                            </label>                            
                        </div>
                    </div>
                    <div v-if="question.draggable" class="draggable">
                        <draggable class="draggable__container" v-model="question.answers" :options="{group:'question' + question.id }" @start="drag=true" @end="onEnd">
                            <div v-for="element in question.answers" :key="element.id" class="draggable__element">{{element.content}}</div>
                        </draggable>
                    </div>
                </div>
                <button class="button button--small button--filled-blue prize__order-button" @click="send" :disabled="submitted">Wyślij &raquo;</button>
            </div>
        </div>
        <page-box-set-widget></page-box-set-widget>
    </div>
</template>

<script>
import Vue from 'vue'
import draggable from 'vuedraggable'

export default {
  name: 'QuizComponent',
  components: {
    draggable
  },
  data () {
    return {
        submitted: false,
        quiz: {}
    }
  },
  beforeRouteEnter(to, from, next) {      
    /**
     * Get current user object.
     */
    Vue.axios.all([
      Vue.axios({
        method: 'get',
        url: '/quizzes/' + to.params.id
      })
    ])
    .then(Vue.axios.spread((notificationsReponse) => {
        next(vm => {
            vm.quiz = notificationsReponse.data.data.quiz[0]
        })
    }))
    .catch(error => next(false))
  },
  methods: {
    send: function() {
        var _this = this
        var formData = new FormData()

        formData.append('quiz_id', this.quiz.id)
        for( var question_ind in this.answers ) {
            var question = this.quiz.questions[question_ind]
            formData.append('question['+question.id+'][answer]', this.answers[question_ind]['answers']);
        }

        Vue.axios({
            method: 'post',
            url: '/quizzes/' + _this.quiz.id + '/submit',
            data: formData
        })
        .then(response => {
            this.$toaster.success(response.data.message)
            _this.submitted = false
        })
        .catch(error => {
            this.$toaster.error(error.response.data.message)
            _this.submitted = false
        })
    },
    onEnd: function(evt) {
        //console.log(evt)
    }
  },
  computed: {
      answers: function() {
          var questions = []
          this.quiz.questions.forEach(function(el, qind) { 
            questions[qind] = {
                'answers': ''
            }
              
            var answer = ''

            if( el.draggable ) {
                el.answers.forEach(function(an, index) {
                    answer += an.order + ','
                })
                questions[qind].answers = answer.substring(0, answer.length-1);
            } else {
                el.answers.forEach(function(an, index) { 
                    //console.log(an)
                    if( an.checked )
                        answer += an.order + ','
                })
                questions[qind].answers = answer.substring(0, answer.length-1);
            }
          })
          return questions
      }
  }
}
</script>



// WEBPACK FOOTER //
// src/app/home/quizes/QuizComponent.vue